import { create } from 'zustand'

interface ProductFiltersState {
  isValid: boolean;
  setIsValid: (value: boolean) => void;
}

export const useProductFiltersStore = create<ProductFiltersState>((set) => ({
  isValid: true,
  setIsValid: (value) => set({ isValid: value }),
}))
